export default "__VITE_ASSET__BKWZydLy__"